const transformValue = (value: unknown) => {
  if (typeof value === 'object') {
    value = JSON.stringify(value);
  }

  const isValidJson = typeof JSON.stringify(value) === 'string';

  if (isValidJson) {
    return value;
  }
};

export const transformObjectToKeyValueArray = (payloadObject: Record<string, unknown>) =>
  Object.keys(payloadObject)
    .map((key) => ({ key, value: transformValue(payloadObject[key]) }))
    .filter((object) => typeof object.value !== 'undefined');
